const invertedMessages = {
  Close: 'CloseLabel',
  Error: 'certs.error',
};

export default invertedMessages;
